import { useContext } from 'react';
import { StorefrontContext } from '../../modules/storefront/providers/StorefrontProvider';

const useStorefront = () => {
  return useContext(StorefrontContext);
};

export default useStorefront;
